// JavaScript Document
	/*$(document).keydown(function(event){
    if(event.which=="17")
        cntrlIsPressed = true;
	});

	$(document).keyup(function(){
	    cntrlIsPressed = false;
	});

	var cntrlIsPressed = false;
	navMenu = false;
	$(document).on('click','#slideSiteMap',function(){
		if (navMenu == false) navMenu = true;
		else navMenu = false;
		$('.menu-level-1').slideToggle('slow');
	});
	$('.datepicker').datepicker();
	
	$(document).on('mouseover','#content',function(){
		if (navMenu == true){
			$('.menu-level-1').slideToggle('slow');
			navMenu = false;
		}
	});*/
	$.fn.serializeObject = function()
    {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

	$('.datepicker').datepicker({ format: 'dd-mm-yyyy'});

	/*$(document).ready(function() {
		if ($(window).width() > 767 ){
			widthWin = $(window).width()-220;
			$('#content').css('width', widthWin+'px'); 
		} else {
			$('#content').css('width', '550px');
		}
	});
	$(window).resize(function() {
		if ($(window).width() > 767 ){
			widthWin = $(window).width()-220;
			$('#content').css('width', widthWin+'px'); 
		} else {
			$('#content').css('width', '548px');
		}
	});
*/	
	/*$(document).on('click','#lateral #menu > LI',function(){
		if ($(this).find('.submenu').css('display') == 'none'){
			$('LI .submenu:not(LI.active .submenu)').slideUp(300);
			$(this).find('.submenu').slideDown(300);
		}
	});

	function slugify(str) {
		str = str.replace(/^\s+|\s+$/g, ''); // trim
		str = str.toLowerCase();

		// remove accents, swap ñ for n, etc
		var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
		var to   = "aaaaeeeeiiiioooouuuunc------";
		for (var i=0, l=from.length ; i<l ; i++) {
		str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
		}

		str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
		.replace(/\s+/g, '-') // collapse whitespace and replace by -
		.replace(/-+/g, '-'); // collapse dashes
		return str;
	}
*/
/*
$(function(){
	$('.datepicker').datepicker({
      autoclose: true
    });
})

	*/

// 	MEJORA MENU RESPONSIVE
function ajustarPosicionSubmenu(submenu) {
	const rect = submenu.getBoundingClientRect();
	const windowHeight = window.innerHeight;
	const espacioRestante = windowHeight - rect.bottom;
	const esMovil = window.matchMedia("(max-width: 768px)").matches; // Puedes ajustar el breakpoint según tu necesidad
  const umbral = esMovil ? windowHeight * 0.35 : windowHeight * 0.40;
	if (espacioRestante < umbral) {
	  const espacioDisponibleArriba = rect.top;
  
	  if (espacioDisponibleArriba > submenu.offsetHeight) {
		console.log(submenu.childrens)
		submenu.style.top = `calc(-100% - 44px)`;
		submenu.style.top = `auto`;
		submenu.style.bottom = `100%`;
	  }
	
	}
  }
  const itemsMenu = document.querySelectorAll('.metismenu > li');
  
  itemsMenu.forEach(item => {
	item.addEventListener('click', (e) => {
	  
	  const submenu = item.querySelector('ul');
	  if (item.classList.contains('mm-active')) {
		ajustarPosicionSubmenu(submenu);
	  }
	});
  });
